"use client";

import { ROUTE_GUTTER_CLASS } from "@/lib/route-layout";
import { cn } from "@/lib/utils";

export default function MissionPage() {
  return (
    <div className={cn("pt-8 pb-6 flex flex-col justify-center items-center min-h-screen text-left bg-background py-6", ROUTE_GUTTER_CLASS)}>
      <h1 className="pt-10 text-5xl font-bold text-foreground mb-4">Our Mission</h1>
      <p className="text-lg text-muted-foreground mb-6">Empowering collectors worldwide</p>

      <div className="w-full max-w-4xl text-foreground pb-8 space-y-6">
        <section>
          <h2 className="text-2xl font-semibold mb-4">Giving Power Back to Collectors</h2>
          <p className="mb-4 text-lg leading-relaxed">
            Kraahl was born from a simple belief: collectors deserve better. For too long, traditional marketplaces have prioritized profits over people, charging excessive fees and creating barriers between passionate collectors.
          </p>
          <p className="mb-4 text-lg leading-relaxed">
            We set out to change that. Our mission is to give power back to collectors by creating a platform designed entirely from the collector's perspective.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4">Built for Collectors, By Collectors</h2>
          <p className="mb-4 text-lg leading-relaxed">
            Every feature on Kraahl has been thoughtfully designed with one goal in mind: to make collecting easier, more accessible, and more rewarding. We understand the thrill of finding that perfect piece, the joy of connecting with fellow enthusiasts, and the importance of fair, transparent transactions.
          </p>
          <p className="mb-4 text-lg leading-relaxed">
            That's why we eliminated selling fees entirely. Your earnings are yours to keep—100% of them. No hidden charges, no commissions, no surprises.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4">Facilitating Meaningful Trades</h2>
          <p className="mb-4 text-lg leading-relaxed">
            Beyond just buying and selling, Kraahl is about building connections. We've created a global community where collectors can share their passion, discover unique pieces, and trade with confidence.
          </p>
          <p className="mb-4 text-lg leading-relaxed">
            Every transaction is secured through PayPal, ensuring peace of mind for both buyers and sellers. We've streamlined the entire process to make it as simple and intuitive as possible.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4">Our Commitment</h2>
          <p className="mb-4 text-lg leading-relaxed">
            We're committed to continuously improving Kraahl based on your feedback. This platform exists to serve collectors, and we're dedicated to making it the easiest and best marketplace for collectibles in the world.
          </p>
          <p className="mb-4 text-lg leading-relaxed">
            Whether you're a seasoned collector or just starting your journey, Kraahl is here to support you every step of the way. Welcome to a marketplace that truly puts collectors first.
          </p>
        </section>

        <section className="pt-8 border-t border-border/20">
          <p className="text-center text-muted-foreground italic">
            Join us in building the future of collecting. Together, we're creating something special.
          </p>
        </section>
      </div>
    </div>
  );
}

